/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgErrorBranch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M19 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm-2.519-6.856.707-.707 4.42 4.42-.708.706zm2.15 8.722c-.606 2.207-1.898 3.812-3.414 4.927-1.736 1.278-3.746 1.902-5.322 2.122A4.002 4.002 0 0 1 2 18a4.002 4.002 0 0 1 3-3.874V2h2v12.126A4.008 4.008 0 0 1 9.847 16.9c1.267-.21 2.842-.73 4.186-1.718 1.207-.888 2.243-2.16 2.707-3.986a6.95 6.95 0 0 0 1.892.67zM4 18a2 2 0 1 0 4 0 2 2 0 0 0-4 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgErrorBranch as ErrorBranch };
